export var TradevestDepositMethod;
(function (TradevestDepositMethod) {
    TradevestDepositMethod["GUTHABENKONTO"] = "GUTHABENKONTO";
    TradevestDepositMethod["FINAPI"] = "FINAPI";
})(TradevestDepositMethod || (TradevestDepositMethod = {}));
export var TradevestDepositStatus;
(function (TradevestDepositStatus) {
    TradevestDepositStatus["INITIATED"] = "INITIATED";
    TradevestDepositStatus["AWAITING_SCA"] = "AWAITING_SCA";
    TradevestDepositStatus["SUBMITTED"] = "SUBMITTED";
    TradevestDepositStatus["COMPLETED"] = "COMPLETED";
    TradevestDepositStatus["FAILED"] = "FAILED";
    TradevestDepositStatus["EXPIRED"] = "EXPIRED";
})(TradevestDepositStatus || (TradevestDepositStatus = {}));
export const TRADEVEST_DEPOSIT_MARKER_PREFIX = 'MG-DEP-';
export const buildTradevestDepositMarker = (id) => `${TRADEVEST_DEPOSIT_MARKER_PREFIX}${id}`.slice(0, 35);
export const buildTradevestDepositReference = (marker) => `mygate Einzahlung ${marker}`;
export const extractTradevestDepositMarker = (text) => (text && text.match(/MG-DEP-[A-Za-z0-9]+/)?.[0]) || undefined;
//# sourceMappingURL=tradevest-deposit.types.js.map